/**
 * Thin route wrapper — fetches policy content by id and renders it
 * through the shared PolicyPageShell. New policies are added by
 * dropping them into `policyContent.POLICIES` and exporting a one-line
 * component below.
 */
import React from "react";
import { Navigate } from "react-router-dom";
import PolicyPageShell from "./PolicyPageShell";
import { POLICIES } from "./policyContent";

export const makePolicyPage = (policyId) => {
  const Comp = () => {
    const content = POLICIES[policyId];
    if (!content) return <Navigate to="/legal" replace />;
    return <PolicyPageShell content={content} />;
  };
  Comp.displayName = `Policy_${policyId}`;
  return Comp;
};

// Concrete components — one per route.
export const AcceptableUsePage = makePolicyPage("acceptable-use");
export const VendorMarketplaceStandardsPage = makePolicyPage("vendor-marketplace-standards");
export const BookingRefundDisputePolicyPage = makePolicyPage("booking-refund-dispute-policy");
export const CommunicationsPolicyPage = makePolicyPage("communications-policy");
export const DataSecurityPage = makePolicyPage("data-security");
export const CookiePolicyPage = makePolicyPage("cookie-policy");
export const DataRetentionPage = makePolicyPage("data-retention");
export const ReviewsPolicyPage = makePolicyPage("reviews-policy");
export const InfluencerDisclosurePage = makePolicyPage("influencer-disclosure");
export const TrademarkPolicyPage = makePolicyPage("trademark-policy");
export const SubscriptionTermsPage = makePolicyPage("subscription-terms");
export const VendorPayoutPolicyPage = makePolicyPage("vendor-payout-policy");
export const AIDisclosurePage = makePolicyPage("ai-disclosure");
export const PhotoMediaPolicyPage = makePolicyPage("photo-media-policy");
export const PropertyDamagePolicyPage = makePolicyPage("property-damage-policy");
export const DMCAAgentPage = makePolicyPage("dmca-agent");
